// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IPaC","importantInfo":"styles_importantInfo__vZajP"};